import styled from 'styled-components';
import { tokens } from '@snsw-gel/react';

export const ButtonContainer = styled.div`
  margin-top: 2.5rem;

  @media screen and (min-width: ${tokens.breakpoints.md}px) {
    margin-top: 3.5rem;
  }
`;
